import type { RouteBadge, SupSinglePreparedRoute } from "@/components/Web3/Common/Route/utils/prepareProviderRoutes";
import type { Web3TxRoutes } from "@/hooks/tx-flow/useDepositCalculate";
import type { SupTransactionType, SupWeb3TxSingleVault } from "@/types";
import { formatUnits } from "@ethersproject/units";
import moment from "moment";

export function processProviderRoutes(routeData: Web3TxRoutes | undefined, singleVault: SupWeb3TxSingleVault, type: SupTransactionType): SupSinglePreparedRoute[] {
  if (!routeData?.routes.length) {
    return [] as SupSinglePreparedRoute[];
  }

  return routeData.routes.map(route => {
    const toAmountInUsd = route.to_amount_usd;

    // Difference between depositing amount in USD and received amount in USD
    const difference = () => {
      const depositing = singleVault.amountInFiat?.toUnsafeFloat() || 0;
      const totalPercentDifference = toAmountInUsd / (depositing / 100);
      return totalPercentDifference < 100 ? (100 - totalPercentDifference) * -1 : `+${totalPercentDifference - 100}`;
    };

    // Calculating estimated time for the route
    const estimatedTime = route.estimate_time;

    return {
      approvalAddress: route.lifi_route_first_step?.estimate.approvalAddress,
      badges: [] as RouteBadge[],
      bridge: route.bridge,
      dex: route.dex,
      difference: difference(),
      erc20_route_approval_target: route.erc20_route_approval_target !== "" ? route.erc20_route_approval_target : undefined,
      estimatedTime: estimatedTime < 60 ? `~${estimatedTime}s` : `~${moment.duration(estimatedTime, "seconds").asMinutes().toFixed(1)} mins`,
      fees: {
        gasCost: route.gas_cost_usd,
        crossChainFee: route.cross_chain_fee,
      },
      id: route.route_id,
      isERC20: route.is_erc20,
      service: route.service,
      simulationAmount: type === "withdraw" ? `${routeData.in.superpositions_amount_in ?? 0}` : route.to_amount !== "" ? route.to_amount : 0,
      superPosition: route.super_position,
      toAmount: route.to_amount !== "" && formatUnits(route.to_amount, route.to_token.decimals),
      toAmountInUsd,
      toAmountMin: route.to_amount_min,
      toMinAmount: route.to_amount_min !== "" && formatUnits(route.to_amount_min, route.to_token.decimals),
      toToken: route.to_token,
      vaultDecimals: routeData.in.vault_decimals,
      vault_id: singleVault.id, // @todo: check if the to_amount
      // is correct
    } as SupSinglePreparedRoute;
  });
}
